module.exports = __webpack_public_path__ + "img/logo.7e9113db.svg";